import './style.less';

export default function(ResolveClass) {
  'ngInject';

  const vm = this;

  vm.applicationSettings = feature => {
    return ResolveClass.applicationSettings(feature);
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/dashboard/controller.js